import { SubscriptionComparison, SubscriptionTierInfo, SubscriptionFeature } from '../models/subscription/subscription.model';

/**
 * Subscription tiers information
 */
export const SUBSCRIPTION_TIERS: SubscriptionTierInfo[] = [
  {
    id: 'free',
    name: 'Base Tier',
    price: 'Free',
    priceMonthly: 0,
  },
  {
    id: 'gamemaster',
    name: 'Game Master Tier',
    price: '$5 USD/month',
    priceMonthly: 5,
  },
];

/**
 * Subscription features comparison
 */
export const SUBSCRIPTION_FEATURES: SubscriptionFeature[] = [
  {
    id: 'play-games',
    description: 'Play games made by Game Masters',
    availableInFree: true,
    availableInGameMaster: true,
  },
  {
    id: 'create-locally',
    description: 'Create your own games locally *',
    availableInFree: true,
    availableInGameMaster: true,
  },
  {
    id: 'use-content-packs',
    description: 'Use Content Packs in your games',
    availableInFree: true,
    availableInGameMaster: true,
  },
  {
    id: 'invite-collaborators',
    description: 'Invite other Game Masters to work asynchronously on your game',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
  {
    id: 'realtime-collaboration',
    description: 'Real-time synchronous game collaboration with fellow Game Masters',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
  {
    id: 'cloud-saves',
    description: 'Cloud saves of all work',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
  {
    id: 'create-content-packs',
    description: 'Create & publish Content Packs',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
  {
    id: 'one-click-publishing',
    description: 'One-Click publishing of your game on Adventure Forge',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
  {
    id: 'shareable-link',
    description: 'Shareable link others to play your game',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
  {
    id: 'export-standalone',
    description: 'Export your game as a stand alone application',
    availableInFree: false,
    availableInGameMaster: true,
    highlighted: true,
  },
];

/**
 * Complete subscription comparison data
 */
export const SUBSCRIPTION_COMPARISON: SubscriptionComparison = {
  tiers: SUBSCRIPTION_TIERS,
  features: SUBSCRIPTION_FEATURES,
  footnote: '* To export and share your games, upgrade to the Game Master Tier',
};
